const environmentProd = {
  url: "./eir/v1"
};

const environmentDev = {
  url: "https://sandbox-eirgw.stg.rmn.local/eir/v1"
};

const environment = process.env.NODE_ENV === 'production' ? environmentProd : environmentDev;

export default environment;
